export default class Select {
	constructor() {
		$( '.attribute select' ).each( function() {
			var $this = $( this );

			var select2_args = $.extend({
				placeholder: $this.attr( 'data-placeholder' ) || $this.attr( 'placeholder' ) || '',
				label: $this.attr( 'data-label' ) || null,
				width: '100%',
				minimumResultsForSearch: 100
			}, {} );

			$( this )
				.on( 'select2:select', function(e) {
					$( this ).trigger( 'focus' );
				} )
				.selectWoo( select2_args );
		});
	}
}